export default function ReasonsSection() {
  const reasons = [
    {
      number: '01',
      title: '一人ひとりに向き合う',
      description: 'マニュアル通りの介護ではなく、ご利用者様の個性や生活スタイルを尊重し、その方に合ったケアを提供します。',
      bgColor: 'bg-pink-50',
      iconBg: 'bg-cyan-500'
    },
    {
      number: '02',
      title: '充実した教育体制',
      description: '未経験の方でも安心してスタートできるよう、丁寧な研修とOJTを実施。資格取得支援も充実しています。',
      bgColor: 'bg-emerald-50',
      iconBg: 'bg-cyan-500'
    },
    {
      number: '03',
      title: '働きやすい環境',
      description: 'ライフスタイルに合わせた柔軟なシフト制度と、チームで支え合う温かい職場環境を整えています。',
      bgColor: 'bg-amber-50',
      iconBg: 'bg-cyan-500'
    }
  ];

  return (
    <section className="py-24 bg-gray-50 observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12">
        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-16">
          選ばれる3つの理由
        </h2>

        <div className="grid md:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className={`${reason.bgColor} rounded-3xl p-10 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-2`}
            >
              <div className={`w-16 h-16 ${reason.iconBg} rounded-full flex items-center justify-center mb-6`}>
                <i className="ri-heart-line text-3xl text-white"></i>
              </div>
              
              <div className="text-cyan-600 font-bold text-lg mb-3">
                {reason.number}
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {reason.title}
              </h3>
              
              <p className="text-gray-700 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
